import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileResetPassword = _resolveComponent("ProfileResetPassword")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(_component_ProfileResetPassword, { class: "mx-auto max-w-400" })
    ]),
    _: 1
  }))
}